import { i18n_config_default } from './chunk-EJ2TIXJU.mjs';

// src/helpers/factories/courseDropdownFactory.ts
var courseDropdownRegisterFactory = (courses, defaultCourseId, coursingMode) => {
  return [
    Object.values(courses).filter((course) => course.type === coursingMode).map((course) => ({
      value: course.courseId,
      label: coursingMode === "on_the_fly" /* ON_THE_FLY */ ? `Course ${course.courseName}` : defaultCourseId === course.courseId ? course.courseName : `as ${course.courseName}`
    }))
  ];
};
var courseDropdownFactory = (courses) => {
  return [
    Object.values(courses).map((course) => ({
      value: course.courseId,
      label: [
        course.name,
        course.active ? "" : ` (${i18n_config_default.t("commonTexts.inactive")})`
      ].join(""),
      textProps: course.active ? void 0 : { color: "persistentSemanticRed" }
    }))
  ];
};

export { courseDropdownFactory, courseDropdownRegisterFactory };
